import { useCallback, useEffect, useState } from 'react';
import { useAtomValue } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { dashboardFilterAtom } from '../filterAtom';
import { dashboardClientAPIAtom, dashboardColumnFilterModelAtom } from '../atoms';

export const useClearFilters = () => {
  const [agGridFilterCount, setAgGridFilterCount] = useState(0);
  const resetFilters = useResetAtom(dashboardFilterAtom);
  const resetColumnFilterModel = useResetAtom(dashboardColumnFilterModelAtom);
  const gridApi = useAtomValue(dashboardClientAPIAtom);
  const filters = useAtomValue(dashboardFilterAtom);

  // Computed directly from the atom — always in sync, no useState needed
  const isMyOrchestrationsActive = filters.jobsOwner === 'USER_JOBS';
  const filterCount = agGridFilterCount + (isMyOrchestrationsActive ? 1 : 0);

  const updateAgGridFilterCount = useCallback(() => {
    setAgGridFilterCount(
      gridApi ? Object.keys(gridApi?.getFilterModel() || {}).length : 0
    );
  }, [gridApi]);

  useEffect(() => {
    if (!gridApi) {
      return undefined;
    }

    updateAgGridFilterCount();

    gridApi.addEventListener('filterChanged', updateAgGridFilterCount);
    return () => {
      gridApi.removeEventListener('filterChanged', updateAgGridFilterCount);
    };
  }, [gridApi, updateAgGridFilterCount]);

  const handleClearFilters = () => {
    if (gridApi) {
      gridApi.setFilterModel(null);
      gridApi.onFilterChanged();
    }
    resetFilters();
    resetColumnFilterModel();
  };

  return {
    activeFilterCount: filterCount,
    handleClearFilters,
    hasActiveFilters: filterCount > 0,
  };
};
